import { render, staticRenderFns } from "./5a367ed7-5efd-4c98-8a2c-041777449668.vue?vue&type=template&id=0afa8aa4&scoped=true"
import script from "./5a367ed7-5efd-4c98-8a2c-041777449668.vue?vue&type=script&lang=ts"
export * from "./5a367ed7-5efd-4c98-8a2c-041777449668.vue?vue&type=script&lang=ts"
import style0 from "./5a367ed7-5efd-4c98-8a2c-041777449668.vue?vue&type=style&index=0&id=0afa8aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa8aa4",
  null
  
)

export default component.exports